import { createExternalRouteRef } from '@backstage/core-plugin-api';

const catalogIndexRouteRef = createExternalRouteRef({
  id: "catalog-index"
});

export { catalogIndexRouteRef as c };
//# sourceMappingURL=routes-e3daad75.esm.js.map
